<template>
  <div>배송정보 연동!</div>
</template>

<script>
export default {
  name: 'DeliveryCheck',
  components: {
    //
  },
  setup(_, { emit }) {
    //

    return {
      //
    }
  },
}
</script>

<style></style>
